var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[(_vm.title)?_c('h2',[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.description)?_c('span',{staticClass:"subtitle-1"},[_vm._v(_vm._s(_vm.description))]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }